export default __webpack_public_path__ + "style/000-style.css";